import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'next-i18next';

import ReadMoreButtonStyle from './style';

import { ExpandMoreProps } from 'src/interfaces/app';

const ReadMoreButton = (props: ExpandMoreProps) => {
  const { t } = useTranslation('common');
  const { expand, title_expand, title_unexpand, icon = true, onClick } = props;

  return (
    <ReadMoreButtonStyle onClick={onClick} endIcon={icon && <ExpandMoreIcon />} expand={expand}>
      {!expand ? title_expand : title_unexpand}
    </ReadMoreButtonStyle>
  );
};

export default ReadMoreButton;
